export enum OrganizationType {
  Team = "team",
  Individual = "individual",
}

export enum OrganizationTier {
  Free = "free",
  Premium = "premium",
}

export enum OrganizationStatus {
  Provisioning = "provisioning",
  Active = "active",
  Deprovisioning = "de-provisioning",
}

export enum RobotoRegion {
  UsEast = "us-east",
  UsWest = "us-west",
  UsGovWest = "us-gov-west",
  EuCentral = "eu-central",
}

export const humanReadableRobotoRegion = (region: RobotoRegion): string => {
  switch (region) {
    case RobotoRegion.UsEast:
      return "US East";

    case RobotoRegion.UsWest:
      return "US West";

    case RobotoRegion.UsGovWest:
      return "US Gov West";

    case RobotoRegion.EuCentral:
      return "EU Central";
  }
};

/**
 * Which event stores an org has. Dataset events (`ev_` IDs, on datasets, files,
 * topics and message paths) live in the legacy store; session events (`evt_`
 * IDs) in the session store. An org moves forward through these, never back:
 *
 * - `legacy`: the legacy store only.
 * - `dual`: both stores, each readable and writable.
 * - `migrating`: both stores; the legacy store is read-only.
 * - `session`: the session store only.
 */
export type EventModel = "legacy" | "dual" | "migrating" | "session";

export interface OrgRecord {
  org_id: string;
  org_type: OrganizationType;
  name: string;
  tier: OrganizationTier;
  status: OrganizationStatus;
  created: string;
  created_by?: string;
  /** Absent from records saved before the field existed; read those as `legacy`. */
  event_model?: EventModel;
}
